import '../../index.css';
var styles = {
  "viewport": "bp_notification_module_viewport--98cd9",
  "root": "bp_notification_module_root--98cd9",
  "container": "bp_notification_module_container--98cd9",
  "mobileContainer": "bp_notification_module_mobileContainer--98cd9",
  "withButtons": "bp_notification_module_withButtons--98cd9",
  "info": "bp_notification_module_info--98cd9",
  "success": "bp_notification_module_success--98cd9",
  "warning": "bp_notification_module_warning--98cd9",
  "error": "bp_notification_module_error--98cd9",
  "typeIconContainer": "bp_notification_module_typeIconContainer--98cd9",
  "typeIcon": "bp_notification_module_typeIcon--98cd9",
  "text": "bp_notification_module_text--98cd9",
  "contentButtonSection": "bp_notification_module_contentButtonSection--98cd9",
  "contentButtons": "bp_notification_module_contentButtons--98cd9",
  "closeButtonSection": "bp_notification_module_closeButtonSection--98cd9",
  "closeButton": "bp_notification_module_closeButton--98cd9"
};
export { styles as default };